import {API} from "../../../api/api";
import {SpecialPrizesPresetsAPIRoutes} from "./apiRoutes";

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const getPresets = ({page, top, search, subsidiaries, types, status, certified}) => {
    let odataParameters = {
        skip: page * top,
        top,
        orderby: "id"
    };

    if (search) {
        odataParameters["search"] = search;
    }

    if (status) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}active eq ${status}`;
    }

    if (certified) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}certified eq ${certified}`;
    }

    if (subsidiaries && subsidiaries.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}subsidiary_id in (${subsidiaries
            .map(c => c)
            .join(",")},)`;
    }

    if (types && types.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";
        odataParameters["filter"] = `${prepend}progressive_type_id eq ${types}`;
    } else {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";
        odataParameters["filter"] = `${prepend}progressive_type_id in (5,6,)`
    }

    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.GET_PRESETS,
        odataParameters
    });
};

const getPreset = presetId => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.GET_PRESET,
        routeParameters: {
            preset_id: presetId
        }
    });
};

const addPreset = json => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.NEW_PRESET,
        parameters: {...json},
        formData: false
    });
};

const editPreset = (presetId, json) => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.EDIT_PRESET,
        parameters: {...json},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const activatePreset = presetId => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.EDIT_PRESET,
        parameters: {active: true},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const deactivatePreset = presetId => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.EDIT_PRESET,
        parameters: {active: false},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

const certifiedPreset = (presetId, certified) => {
    return API.request({
        routeID: SpecialPrizesPresetsAPIRoutes.CERTIFIED_PRESET,
        parameters: {certified: certified},
        routeParameters: {preset_id: presetId},
        formData: false
    });
};

export const specialPrizesPresetsAPI = {
    getSubsidiaries,
    getPresets,
    getPreset,
    addPreset,
    editPreset,
    activatePreset,
    deactivatePreset,
    certifiedPreset
};
